module.exports = {
          srcSet: __webpack_public_path__ + "f47ecf4459ef94b76cf547ef00082560-16.png"+" 16w",
          images:[ {path: __webpack_public_path__ + "f47ecf4459ef94b76cf547ef00082560-16.png",width: 16,height: 16}],
          src: __webpack_public_path__ + "f47ecf4459ef94b76cf547ef00082560-16.png",
          toString:function(){return __webpack_public_path__ + "f47ecf4459ef94b76cf547ef00082560-16.png"},
          
          width: 16,
          height: 16
        }